import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { UserInfo } from '@ca/core/models';
import { SupportService, UserNotificationService, UserService } from '@ca/core/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EMPTY } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { FullNamePipe } from '../../../pipes/full-name/full-name.pipe';

@Component({
    selector: 'ca-result-feedback-modal',
    templateUrl: './result-feedback-modal.component.html',
    styleUrls: ['./result-feedback-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultFeedbackModalComponent implements OnInit {
    feedbackForm: UntypedFormGroup;
    resultId: string;
    shareLinkPrefix: string;

    readonly smileys: Smiley[] = [
        { name: 'face-satisfied', code: '&#128578;', selected: true },
        { name: 'face-neutral', code: '&#128528;', selected: false },
        { name: 'face-dissatisfied', code: '&#128577;', selected: false },
    ];

    get userInfo(): UserInfo | undefined {
        return this.userService.myInfo;
    }
    constructor(
        private activeModal: NgbActiveModal,
        private fullNamePipe: FullNamePipe,
        private supportService: SupportService,
        private userNotificationService: UserNotificationService,
        private userService: UserService,
    ) {}

    ngOnInit(): void {
        this.feedbackForm = new UntypedFormGroup({
            share_result: new UntypedFormControl(true),
            message: new UntypedFormControl(''),
        });
    }

    dismiss(reason?: string) {
        this.activeModal.dismiss(reason);
    }

    selectSmiley(smiley: Smiley): void {
        this.smileys.forEach(x => (x.selected = false));
        smiley.selected = true;
    }

    submit(): void {
        let prefix = '';
        let id = '';
        const shareResult = this.feedbackForm.get('share_result')!.value;

        if (shareResult) {
            prefix = this.shareLinkPrefix;
            id = this.resultId;
        }
        this.userNotificationService.showSpinner();
        this.supportService
            .sendFeedback$(
                this.fullNamePipe.transform(this.userInfo),
                this.userInfo?.email || '',
                (this.feedbackForm.get('message')?.value as string) || '',
                this.getSelectedSmiley()?.code || '',
                prefix,
                id,
            )
            .pipe(
                tap(() => {
                    this.userNotificationService.showSuccess('CONTACT_US.NOTIFICATION.SUCCESS');
                    this.activeModal.close();
                }),
                catchError(() => {
                    this.userNotificationService.showError('CONTACT_US.NOTIFICATION.FAILURE');
                    return EMPTY;
                }),
                finalize(() => {
                    this.userNotificationService.hideSpinner();
                }),
            )
            .subscribe();
    }

    private getSelectedSmiley(): Smiley | undefined {
        return this.smileys.find(x => x.selected);
    }
}

interface Smiley {
    name: string;
    code: string;
    selected: boolean;
}
